import { useState } from "react";
import { BACKEND_URL } from "@/lib/api";
import { ExternalLink, FileText, ChevronDown, ChevronUp } from "lucide-react";

export function ReferenceDocs({ docs = [] }) {
  const [active, setActive] = useState(docs[0]?.key);
  const [open, setOpen] = useState(true);
  const doc = docs.find((d) => d.key === active);
  if (!docs.length) {
    return <div className="ember-card mb-6 p-4 text-sm text-[#948EAB]" data-testid="reference-docs-empty">No homework paper, solutions or workbook is attached to this homework yet.</div>;
  }
  return (
    <div className="ember-card mb-6 overflow-hidden p-0" data-testid="reference-docs">
      <div className="flex flex-wrap items-center gap-2 border-b border-[#F1EEFA] p-3">
        <FileText className="h-4 w-4 text-[#4B2BB8]" />
        <span className="mr-1 text-xs font-bold uppercase tracking-wide text-[#5B21B6]">What you're marking</span>
        {docs.map((d) => (
          <button key={d.key} type="button" onClick={() => { setActive(d.key); setOpen(true); }} data-testid={`ref-doc-tab-${d.key}`}
            className={`rounded-lg px-3 py-1.5 text-sm font-bold transition-colors ${active === d.key ? "bg-[#4B2BB8] text-white" : "text-[#4B2BB8] hover:bg-[#F3F0FF]"}`}>{d.label}</button>
        ))}
        <div className="ml-auto flex items-center gap-3">
          {doc && <a href={`${BACKEND_URL}${doc.url}`} target="_blank" rel="noreferrer" data-testid="ref-doc-open-tab" className="inline-flex items-center gap-1 text-xs font-bold text-[#4B2BB8] hover:underline"><ExternalLink className="h-3.5 w-3.5" /> Open in new tab</a>}
          <button type="button" onClick={() => setOpen((o) => !o)} data-testid="ref-doc-toggle" className="inline-flex items-center gap-1 text-xs font-bold text-[#948EAB] hover:text-[#4B2BB8]">
            {open ? <><ChevronUp className="h-3.5 w-3.5" /> Hide</> : <><ChevronDown className="h-3.5 w-3.5" /> Show</>}
          </button>
        </div>
      </div>
      {open && doc && <iframe key={doc.url} title={doc.label} src={`${BACKEND_URL}${doc.url}#toolbar=1&view=FitH`} className="h-[70vh] w-full" data-testid="ref-doc-viewer" />}
    </div>
  );
}
